import React, {Fragment, useContext, useEffect, useState} from "react";
import CardContainer from "../../../components/CardContainer";
import Card from "../../../components/Card";
import {Link} from "react-router-dom";
import {LoaderContext} from "../../../context/LoaderContext";
import ModalConfirm from "../../../components/ModalConfirm";
import NsDataTable from "../../../components/tabelle/NsDataTable";
import {eliminaMarcaArchivioApi, getMarcheArchivioApi} from "../../../services/ArchivioServices";

function ListMarcheArchivio() {

    const [loadingData, setLoadingData] = useState(true);
    const [marcheArchivio, setMarcheArchivio] = useState([]);
    const [marcaArchivioSel, setMarcaArchivioSel] = useState(null);
    const [show, setShow] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    async function getMarcheArchivio() {
        startChiamata();

        const response = await getMarcheArchivioApi();
        setMarcheArchivio(response.data.data);
        setLoadingData(false);
        endChiamata();
    }

    useEffect(() => {
        if (loadingData === true) {
            getMarcheArchivio();
        }
    }, []);

    const openModalDel = (utente) => {
        setMarcaArchivioSel(utente)
        setShow(true);
    }

    async function deleteMarcaArchivio() {
        startChiamata();

        const response = await eliminaMarcaArchivioApi(marcaArchivioSel.id_archivio_marca);
        setMarcheArchivio(response.data.data);
        endChiamata();
    }

    return (
        <CardContainer>
            <Card
                icon={'fas fa-tags'}
                title={'Marche Archivio'}
                getBottoniDx={() =>
                    <Link to="/upd-marca-archivio" className={"btn btn-card"}>
                        <i className="fas fa-plus-circle"/> Aggiungi
                    </Link>
                }
            >
                <ModalConfirm
                    show={show}
                    handleClose={() => setShow(false)}
                    handleOk={() => {
                        setShow(false);
                        deleteMarcaArchivio();
                    }}
                    testo={"Sicuro di voler eliminare la marca: " + (marcaArchivioSel && (marcaArchivioSel.marca)) + "?"}/>
                {
                    loadingData ? (
                        <p>Caricamento in corso...</p>
                    ) : (
                        <NsDataTable
                            data={marcheArchivio}
                            columns={[
                                {
                                    name: 'Marca archivio',
                                    selector: row => row.marca,
                                    sortable: true,
                                },
                                {
                                    name: '',
                                    selector: row => <Fragment>
                                        <div className="btn-group" role="group"
                                             aria-label="Button group with nested dropdown">
                                            <div className="btn-group" role="group">
                                                <button id="btnGroupDrop1" type="button"
                                                        className="btn btn-dark dropdown-toggle"
                                                        data-bs-toggle="dropdown" aria-expanded="false">
                                                    <i className="fa-solid fa-bars"></i>
                                                </button>
                                                <ul className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                                    <li>
                                                        <Link to={`/upd-marca-archivio/${row.id_archivio_marca}`}
                                                              className="dropdown-item"
                                                              data-toggle="tooltip" title="Modifica">
                                                            <i className="fas fa-pen"/> Modifica
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <button className="dropdown-item"
                                                                data-toggle="tooltip" title="Elimina" onClick={() => {
                                                            openModalDel(row)
                                                        }}>
                                                            <i className="fas fa-trash"/> Elimina
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Fragment>,
                                    sortable: false,
                                    right: true,
                                }
                            ]}
                            addPagination={true}
                            funzioneFiltro={(item, filtro) => {
                                return (item.marca && item.marca.toLowerCase().includes(filtro.toLowerCase()))
                            }}
                        />
                    )}
            </Card>
        </CardContainer>
    );
}

export default ListMarcheArchivio;
